module.exports = __webpack_public_path__ + "media/images/shared/people-group-cc8c971fed4bbe16da2c5b8fb03ece11.svg";